import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Switch, Route, Redirect } from 'react-router-dom';
import Landing from '@pages/Landing';
import Login from '@pages/Login';
import Forgot from '@pages/Forgot';
import Reset from '@pages/Reset';
import Register from '@pages/Register';
import Property from '@pages/Property';
import RequestProperty from '@pages/RequestProperty';
import Home from '@pages/Home';
import Welcome from '@pages/Welcome';
import Account from '@pages/Account';
import MyClean from '@pages/Clean';
import Subscription from '@pages/Subscription';
import BillingHistory from '@pages/BillingHistory';
// import Book from '@pages/Book';
import Moveout from '@pages/Moveout';
import Discontinue from '@pages/Discontinue';
import AppActions, { AppSelectors } from '@redux/AppRedux';
import { AuthSelectors } from '@redux/AuthRedux';
import { SignupSelectors } from '@redux/SignupRedux';
import FullScreenLoader from '@components/loading/FullScreenLoader';
import redirect from '@services/redirect';

import '@utils/polyfill';

class App extends Component {
  static propTypes = {
    loading: PropTypes.bool,
    loaded: PropTypes.bool,
    startup: PropTypes.func,
    isLoggedIn: PropTypes.bool,
    hasProperty: PropTypes.any,
    isSignupFlow: PropTypes.bool,
    isPMUser: PropTypes.bool
  };

  componentDidMount() {
    const { startup } = this.props;

    startup();
  }

  renderAnonRoutes() {
    return (
      <Switch>
        <Route exact path="/auth/" component={Landing} />
        <Route exact path="/auth/login" component={Login} />
        <Route exact path="/auth/forgot" component={Forgot} />
        <Route exact path="/auth/reset" component={Reset} />
        <Route exact path="/auth/register" component={Register} />
        <Route
          render={props => {
            redirect.set(props.location);
            return <Redirect to="/auth" />;
          }}
        />
      </Switch>
    );
  }

  renderUserRoutes({ hasProperty, isSignupFlow, isPMUser }) {
    if (!hasProperty && !isPMUser) {
      return (
        <Switch>
          <Route exact path="/property" component={Property} />
          <Route exact path="/request-property" component={RequestProperty} />
          <Route render={() => <Redirect to="/property" />} />
        </Switch>
      );
    }

    return (
      <Switch>
        <Route exact path="/account" component={Account} />
        <Route exact path="/billing-history" component={BillingHistory} />
        <Route path="/subscription" component={Subscription} />
        <Route exact path="/welcome" component={Welcome} />
        <Route exact path="/home" component={Home} />
        <Route path="/bookings/:bookingId" component={MyClean} />
        {/* <Route exact path="/book" component={Book} /> */}
        <Route exact path="/moveout" component={Moveout} />
        <Route exact path="/discontinue" component={Discontinue} />
        <Route
          render={() => <Redirect to={isSignupFlow ? '/welcome' : '/home'} />}
        />
      </Switch>
    );
  }

  renderContent() {
    const {
      loaded,
      loading,
      isLoggedIn,
      hasProperty,
      isSignupFlow,
      isPMUser
    } = this.props;

    if (!loaded || loading) {
      return <FullScreenLoader />;
    }

    if (!isLoggedIn) {
      return this.renderAnonRoutes();
    }

    return this.renderUserRoutes({ hasProperty, isSignupFlow, isPMUser });
  }

  render() {
    return this.renderContent();
  }
}

const mapStatesToProps = state => ({
  loading: AppSelectors.selectLoading(state),
  loaded: AppSelectors.selectLoaded(state),
  isLoggedIn: AuthSelectors.selectIsLoggedIn(state),
  hasProperty: AuthSelectors.selectCurrentPropertyId(state),
  isSignupFlow: SignupSelectors.selectIsSignupFlow(state),
  isPMUser: AuthSelectors.selectIsPMUser(state)
});

const mapDispatchToProps = dispatch => ({
  startup: () => dispatch(AppActions.startup())
});

export default connect(
  mapStatesToProps,
  mapDispatchToProps
)(App);
